import { ApiError } from "@/shared/api";

export type SubmitErrorNotifier = (message: string) => void;

export function isAbortError(error: unknown): boolean {
  return (
    (error instanceof DOMException && error.name === "AbortError") ||
    (typeof error === "object" &&
      error !== null &&
      Reflect.get(error, "name") === "AbortError")
  );
}

export function notifySubmitError(
  error: unknown,
  notify: SubmitErrorNotifier,
): void {
  if (isAbortError(error)) return;
  // NSFW_REJECTEDは板設定を知るフォーム側で文脈に合う案内を表示する。
  // 共通toastへサーバー文言を流すと、R18スレ作成禁止板でも設定変更を促してしまう。
  if (error instanceof ApiError && error.code === "NSFW_REJECTED") return;
  if (
    error instanceof ApiError &&
    error.code === "POLL_CREATION_RATE_LIMITED"
  ) {
    notify("アンケート付き投稿は少し時間を空けてください。");
    return;
  }
  notify(error instanceof Error ? error.message : "投稿に失敗しました");
}
